module.exports = __webpack_public_path__ + "img/non-evaluated.dae02b94.svg";